import { EditListPopup, PopupComponent, PopupElements } from './edit-list-popup';
import { ActionCreator, AjaxDispatcher } from "./ajax-dispatcher";
import { initCompanyEdit } from './main';


export default class CompanyEdit {
    init(): void {
        const popupElements: PopupElements = {
            addItemButton: null,
            editButtons: Array.from(document.querySelectorAll('[data-action="EditCompany"]')),
            deleteButtons: []
        };
    
        const popupComponent: PopupComponent = {
            displayComponentName: 'CustomerCompanyForm',
            removeItemUrl: null,
            addItemUrlParameters: [
            ],
            editItemUrlParameters: [
            ],
            removeItemUrlParameters: [
            ]
        };
    
        new EditListPopup().init('EditCompanyForm', 'edit-company-form-popup', popupElements, popupComponent, () => this.onFormSubmit());
    }

    private onFormSubmit(): void {
        const action = new ActionCreator().reloadComponent('CustomerInformation');
        
        action.successAction = () => initCompanyEdit();
        new AjaxDispatcher().dispatchGetAction(action);
    }
}
